// extracted by mini-css-extract-plugin
export default {"container":"style_container__jR7MV","text":"style_text__mLIq3","darkText":"style_darkText__i9N8w","locationIcon":"style_locationIcon__bp8B5"};